import JustValidate from 'just-validate';

const customTailoringForm = document.getElementById('custom_tailoring_form');
const validator = new JustValidate('#custom_tailoring_form');

window.onload = function () {
  validator
    .addField('#name', [
      {
        rule: 'required',
        errorMessage: 'Ime je obavezno',
      },
    ])
    .addField('#lastname', [
      {
        rule: 'required',
        errorMessage: 'Prezime je obavezno',
      },
    ])
    .addField('#age', [
      {
        rule: 'required',
        errorMessage: 'Godina rođenja je obavezna',
      },
    ])
    .addField('#phone', [
      {
        rule: 'required',
        errorMessage: 'Telefon je obavezan',
      },
    ])
    .addField('#email', [
      {
        rule: 'required',
        errorMessage: 'E-mail je obavezan',
      },
      {
        rule: 'email',
        errorMessage: 'Email adresa koju ste uneli je nevažeća.',
      },
    ])

    .addField('#agree', [
      {
        rule: 'required',
        errorMessage: "Prihvatanje uslova je obavezno.",
      },
    ],
      {
        errorsContainer: '#terms-error',
      }
    ).onSuccess((() => {
      customTailoringForm.submit()
    })).onFail((() => {
      customTailoringForm.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'start' });
    }))
};